import { useCallback, useState } from 'react';

import { useOpenURL } from '@sg/garnish';

import { useFeatureFlag } from '@order/LaunchDarkly';

import {
  checkIfHasRecentlyDismissedFlexEntryPoint,
  storeDismissedFlexEntryPointDate,
} from '../../utils';

/**
 * The flex entry point is a component that allows the customer to enroll in the flex program.
 * - Should not be shown if the customer already enrolled to flex.
 * - Should not be shown if the customer has just checked their eligibility.
 * - Should not be shown if the customer has dismissed the flex entry point in the last 30 days.
 */
export const useFlexEntryPoint = () => {
  const isFeatureEnabled = useFeatureFlag('CELS-5522-flex-enabled');

  const hasEnrolledToFlex = false; // to be replaced by graphql query.

  const [hasCheckedEligibility, setHasCheckedEligibility] = useState(false);

  const [hasRecentlyDismissedFlexCheck, setHasRecentlyDismissedFlexEntryPoint] = useState(
    checkIfHasRecentlyDismissedFlexEntryPoint(),
  );

  const openUrl = useOpenURL();

  const checkFlexEligibility = useCallback(() => {
    openUrl(FLEX_WEBSITE);
    setHasCheckedEligibility(true);
  }, [openUrl]);

  const dismissFlexEntryPoint = useCallback(() => {
    setHasRecentlyDismissedFlexEntryPoint(true);
    storeDismissedFlexEntryPointDate();
  }, []);

  const shouldRenderFlexEntryPoint =
    isFeatureEnabled &&
    !hasEnrolledToFlex &&
    !hasCheckedEligibility &&
    !hasRecentlyDismissedFlexCheck;

  return { shouldRenderFlexEntryPoint, checkFlexEligibility, dismissFlexEntryPoint };
};

// ─── Constants ───────────────────────────────────────────────────────────────

const FLEX_WEBSITE = 'https://app.getflex.com/';
